module.exports = __webpack_public_path__ + "static/media/links-of-northville.3062b01d.pdf";